/* eslint-disable */
import OSS from "ali-oss";
import store from "@/store";
import { apiLogRecord } from "@/api/common";
import storage from "@/utils/storage";

/**
 * 将后端 region（如 cn-beijing）转为 ali-oss 所需格式（oss-cn-beijing）
 */
function normalizeOssRegion(region) {
  if (!region || typeof region !== "string") return "";
  const r = region.trim();
  if (r.startsWith("oss-")) return r;
  return `oss-${r}`;
}

/**
 * 从 vuexInitData.cpub 读取 OSS STS（与 init 接口字段一致）
 */
function getOssConfig() {
  const initData = store.getters.vuexInitData || {};
  const raw = initData.cpub || null;
  if (!raw || typeof raw !== "object") return null;

  const accessKeyId = raw.access;
  const accessKeySecret = raw.secret;
  const stsToken = raw.securitytoken;
  const bucket = raw.bucket;
  const regionNorm = normalizeOssRegion(raw.region);
  const cdnDomain = String(raw.cdn_domain || "").replace(/\/$/, "");

  if (!regionNorm || !bucket || !accessKeyId || !accessKeySecret || !stsToken) {
    return null;
  }

  const expiresAt = raw.expires_at;
  if (expiresAt) {
    const t = Date.parse(expiresAt);
    if (!Number.isNaN(t) && t <= Date.now()) {
      return { expired: true };
    }
  }

  return {
    region: regionNorm,
    bucket,
    accessKeyId,
    accessKeySecret,
    stsToken,
    cdnDomain,
  };
}

function fnGetExtension(file) {
  const fileName = file.name;
  const patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
  return fileName.match(patternFileExtension);
}

/**
 * 阿里云 OSS 简单上传（与 uploadFileMulti 的 Promise 形态兼容，resolve { key }）
 * @param {*} params 同 upload.js：file、key（可选覆盖）、accept、progressCb、uploadingCb
 */
function uploadFileOss(params) {
  return new Promise((resolve, reject) => {
    const cfg = getOssConfig();
    if (!cfg) {
      reject({ msg: "未配置 OSS 上传凭证（cpub）" });
      return;
    }
    if (cfg.expired) {
      reject({ msg: "OSS 临时凭证已过期，请刷新页面重试" });
      return;
    }
    if (!params.file) {
      reject({ msg: "请选择文件" });
      return;
    }
    if (params.accept) {
      const extMatch = fnGetExtension(params.file);
      const extPart =
        extMatch && extMatch[1] ? String(extMatch[1]).toLowerCase() : "";
      if (extPart && !params.accept.includes(extPart)) {
        reject({
          msg: `请上传符合以下格式的文件：${params.accept}`,
        });
        return;
      }
    }

    let objectKey = `kf_web/${storage.getGameId() || 0}/`;
    objectKey +=
      new Date().getTime() + "_" + parseInt(Math.random() * 100000000, 10);
    const ext = fnGetExtension(params.file);
    if (ext && ext[0]) objectKey += ext[0];
    if (params.key) objectKey = params.key;

    const clientOpts = {
      region: cfg.region,
      accessKeyId: cfg.accessKeyId,
      accessKeySecret: cfg.accessKeySecret,
      stsToken: cfg.stsToken,
      bucket: cfg.bucket,
      secure: true,
    };
    const client = new OSS(clientOpts);

    client
      .put(objectKey, params.file, {
        progress: (p) => {
          const percent = (p * 100).toFixed(2);
          if (params.progressCb) params.progressCb(Number(percent));
        },
      })
      .then(() => {
        if (params.progressCb) params.progressCb(100);
        const cdnBase = cfg.cdnDomain;
        const fileUrl = cdnBase ? `${cdnBase}/${objectKey}` : objectKey;
        apiLogRecord({
          file_url: fileUrl,
          source: "im",
        });
        resolve({ key: fileUrl });
      })
      .catch((err) => {
        console.error("OSS upload error:", err);
        reject(err);
      });
  });
}

export { uploadFileOss };
